var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundWaveform(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 452,
    height: 30,
    viewBox: "0 0 452 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 4,
    width: 4,
    height: 26,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 13,
    width: 4,
    height: 17,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 8,
    width: 4,
    height: 22,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 11,
    width: 4,
    height: 19,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    width: 4,
    height: 30,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 4,
    width: 4,
    height: 26,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 13,
    width: 4,
    height: 17,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 8,
    width: 4,
    height: 22,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 11,
    width: 4,
    height: 19,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    width: 4,
    height: 30,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 4,
    width: 4,
    height: 26,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 13,
    width: 4,
    height: 17,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 8,
    width: 4,
    height: 22,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 11,
    width: 4,
    height: 19,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 196,
    width: 4,
    height: 30,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 4,
    width: 4,
    height: 26,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 13,
    width: 4,
    height: 17,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 8,
    width: 4,
    height: 22,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 11,
    width: 4,
    height: 19,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 266,
    width: 4,
    height: 30,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 4,
    width: 4,
    height: 26,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 13,
    width: 4,
    height: 17,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 308,
    y: 8,
    width: 4,
    height: 22,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 11,
    width: 4,
    height: 19,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 336,
    width: 4,
    height: 30,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 4,
    width: 4,
    height: 26,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 11,
    width: 4,
    height: 19,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 378,
    width: 4,
    height: 30,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 4,
    width: 4,
    height: 26,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 13,
    width: 4,
    height: 17,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 8,
    width: 4,
    height: 22,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 11,
    width: 4,
    height: 19,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 448,
    width: 4,
    height: 30,
    rx: 2,
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundWaveform);
export default __webpack_public_path__ + "static/media/sound-waveform.f17ed915679a6c572568d9edc09f82a5.svg";
export { ForwardRef as ReactComponent };